import LeadingLinks from '../../components/leading-links';
import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import MainLayout from '../../components/layouts/main-layout';
import HeroImage from '../../public/img/hero/corporate_governance_1920_640.jpg';
import AsxCorporateGovernanceDocs from '../../components/asx/asx-corporate-governance-docs';
import DocumentList from '../../components/document-list/document-list';
import Head from 'next/head';

export default function CorporateGovernance() {
    return (
        <MainLayout>
            <Head>
                <title>Corporate Governance | Solvar</title>
                <meta name="description" content="Solvar corporate governance."></meta>
            </Head>
            <AsideLayout
                prev={
                    <LeadingLinks href="/about-us/management-team" prev>Management Team</LeadingLinks>
                }
                next={
                    <LeadingLinks href="/about-us/philanthropy" next>Philanthropy</LeadingLinks>
                }
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">About Us</span> › Corporate Governance
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance" active={true}>Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Corporate Governance</h1>
                <div className="sol-markdown-content">
                    <p>We recognise and are committed to the highest standards of corporate governance, transparency and establishing accountability. This is vital for the performance of our organisation and to safeguard the interests of our shareholders. The Company regularly reviews its governance framework, policies and practices to ensure they are consistent with best practices.</p>
                    <p>The Company has complied with the fourth edition of the ASX Corporate Governance Council's Corporate Governance Principles and Recommendations (ASX Recommendations) and published its Annual Corporate Governance Statement, disclosing the extent to which it has followed the ASX Recommendations for the applicable reporting period and identified any recommendations that it has not followed as well as providing reasons for not following the recommendation. </p>
                </div>
                <AsxCorporateGovernanceDocs className="mb-6" />
                <DocumentList className="mb-6" heading="Corporate Governance Documents" items={
                    [
                        {
                            title: "Company Constitution",
                            href: "/docs/09-09-2024-solvar-constitution.pdf"
                        },
                        {
                            title: "Board Charter",
                            href: "/docs/2026-05-29-board-charter.pdf"
                        },
                        {
                            title: "Audit Risk Compliance Committee Charter",
                            href: "/docs/2026-05-29-audit-risk-and-compliance-committee-charter.pdf"
                        },
                        {
                            title: "Remuneration & Nomination Committee Charter",
                            href: "/docs/2026-05-29-remuneration-and-nomination-committee-charter.pdf"
                        },
                        {
                            title: "Share Trading Policy",
                            href: "/docs/2025-05-26-solvar-share-trading-policy.pdf",
                        },
                        {
                            title: "Continuous Disclosure and Investor Relations Policy",
                            href: "/docs/2026-05-29-continuous-disclosure-and-investor-relations-policy.pdf"
                        },
                        {
                            title: "Code of Conduct Policy",
                            href: "/docs/01-09-2025-code-of-conduct-policy.pdf",
                        },
                        {
                            title: "Conflict of Interest",
                            href: "/docs/2026-05-29-conflict-of-interest-policy.pdf"
                        },
                        {
                            title: "Whistleblower Policy",
                            href: "/docs/2026-05-29-whistleblower-policy.pdf"
                        },
                        {
                            title: "Diversity Policy",
                            href: "/docs/2026-05-29-diversity-policy.pdf"
                        },
                        {
                            title: "Human Rights Policy",
                            href: "/docs/2026-05-29-human-rights-policy.pdf"
                        },
                        {
                            title: "Sustainability Policy",
                            href: "/docs/2026-05-29-sustainability-policy.pdf"
                        },
                        {
                            title: "Sustainability Committee Charter",
                            href: "/docs/2024-09-20-sustainability-committee-charter.pdf"
                        }
                    ]
                } />
                <DocumentList className="mb-6" heading="Workplace Gender Equality" items={
                    [
                        {
                            title: "2021 WGEA Report",
                            href: "/docs/04-10-2021-Money3-WGEA-Report-2021.pdf"
                        },
                        {
                            title: "2022 WGEA Report",
                            href: "/docs/Money3 WGEA 2021 - 2022.pdf"
                        },
                        {
                            title: "2023 WGEA Report",
                            href: "/docs/WGEA 2022-2023.pdf"
                        },
                        {
                            title: "2024 WGEA Report",
                            href: "/docs/WGEA FY24.pdf"
                        },
                        {
                            title: "2025 WGEA Report",
                            href: "/docs/2026-07-21-WGEA-Report-2025.pdf"
                        }
                    ]
                } />
                <DocumentList heading="Employee Equity Plans" items={
                    [
                        {
                            title: "Employee Equity Plan",
                            href: "/docs/employee-equity-plan-rules.pdf"
                        },
                        {
                            title: "Exempt Employee Share Plan",
                            href: "/docs/exempt-employee-share-plan-rules.pdf"
                        },
                    ]
                } />
            </AsideLayout>
        </MainLayout>
    );
}